import { render, staticRenderFns } from "./PaymentCardPopup.vue?vue&type=template&id=5f594e6b&"
import script from "./PaymentCardPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentCardPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports